import { createContext } from "react";

const OCRContext = createContext();

export default OCRContext;
